import React from 'react';

const ErrorMsg = ({error}) => {
  return <p style={{color: '#dc3545'}}>{error}</p>
};

export const ErrorApiMsg = ({error}) => {
  return <p style={{backgroundColor: '#dc3545', color:'white', padding: '12px', borderRadius: '5px', marginTop: '5px', display: 'block'}}>{error}</p>
};

export const SuccessApiMsg = ({msg}) => {
  return <p style={{backgroundColor: '#28a745', color:'white', padding: '12px', borderRadius: '5px', marginTop: '5px', display: 'block'}}>{msg}</p>
};

export const ErrorCupomMsg = ({error}) => {
  return <p style={{backgroundColor: '#dc3545', color:'white', padding: '12px', borderRadius: '5px', marginTop: '5px', display: 'block'}}>{error}</p>
};

export const SuccessCupomMsg = ({msg}) => {
  return <p style={{backgroundColor: '#28a745', color:'white', padding: '12px', borderRadius: '5px', marginTop: '5px', display: 'block'}}>{msg}</p>
};

export default ErrorMsg;